import { FETCH_COUNTRY_REQUEST, FETCH_COUNTRY_SUCCESS, FETCH_COUNTRY_ERROR } from '../constants/ActionTypes';

export default function isFetchingCountry(state = false, action) {
    switch (action.type) {
        case FETCH_COUNTRY_REQUEST:
            return true;
        case FETCH_COUNTRY_SUCCESS:
        case FETCH_COUNTRY_ERROR:
            return false;
        default:
            return state;
    }
}
